import { render, staticRenderFns } from "./_position.vue?vue&type=template&id=172ea136&scoped=true&"
import script from "./_position.vue?vue&type=script&lang=js&"
export * from "./_position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172ea136",
  null
  
)

export default component.exports